<template>
  <div class="container">
    <!-- <van-list
      v-model="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    > -->
    <van-cell-group inset>
      <van-cell v-for="item in list" :key="item.id">
        <div class="item-container">
          <div class="item-left">
            <div>
              <span>姓名：</span>
              <span>{{ item.name }}</span>
            </div>
          </div>
          <div>
            <van-image
              width="100"
              height="130"
              fit="cover"
              :src="item.avatar"
            />
          </div>
        </div>
      </van-cell>
    </van-cell-group>
    <!-- </van-list> -->
  </div>
</template>

<script>
import { List, Cell, CellGroup, Image as VanImage } from 'vant'

export default {
  components: {
    [List.name]: List,
    [Cell.name]: Cell,
    [VanImage.name]: VanImage,
    [CellGroup.name]: CellGroup
  },
  data () {
    return {
      list: [
        {
          id: 1,
          avatar: 'http://www.ufc.cn//Upload/Ranking/0df1187b-b3ed-4182-9ab4-3c292d9ce007.png',
          name: '伊斯兰姆-马哈切夫'
        },
        {
          id: 2,
          avatar: 'http://www.ufc.cn//Upload/Ranking/0df1187b-b3ed-4182-9ab4-3c292d9ce007.png',
          name: '伊斯兰姆-马哈切夫'
        }
      ],
      loading: false,
      finished: false
    }
  },
  methods: {
    onLoad () {
      console.log('dfsd')
    }
  }
}
</script>

<style scoped>
.container {
  padding: 20px 0 0 0;
}
.item-container {
  display: flex;
  justify-content: space-between;
}
.item-left {
  display: flex;
  align-items:center;
}
</style>
